module.exports = __webpack_public_path__ + "static/media/leonie-icon.b5ffd755.png";